// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28759":"1b37925c","85754":"61189bbc"}[chunkId] + ".chunk.css";
};